import { render, staticRenderFns } from "./add-reservation.vue?vue&type=template&id=6653cbce&scoped=true&"
import script from "./add-reservation.vue?vue&type=script&lang=js&"
export * from "./add-reservation.vue?vue&type=script&lang=js&"
import style0 from "./add-reservation.vue?vue&type=style&index=0&id=6653cbce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6653cbce",
  null
  
)

export default component.exports